import { Box, Typography, Chip } from '@mui/material';
import useDevice from 'hooks/useDevice';
import React from 'react';
import { Link } from 'react-router-dom';
import { paths } from 'routes/routes/paths';
interface FeaturedCaseStudiesProps {
  type: string;
  projects: any[];
  isSlider?: boolean;
  hideShadow?: boolean;
}

const FeaturedCaseStudies: React.FC<FeaturedCaseStudiesProps> = ({
  type,
  projects,
  isSlider,
  hideShadow,
}) => {
  const { screenWidth, isMobile } = useDevice();

  return (
    <Box sx={screenWidth <= 768 ? { maxWidth: '430px', margin: 'auto' } : {}}>
      {/* Section Heading */}
      <Typography
        variant="h2"
        className="font-satoshi-regular"
        title="Custom Software & ERP Project Case Studies"
        sx={{
          background: 'linear-gradient(270.11deg, #177BFF 23.63%, #0F1C3F 123.03%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontSize: '24px',
          textAlign: type === 'web' ? 'center' : 'left',
          lineHeight: 1.3,
        }}
      >
        <Box component="span" className="font-satoshi-black" sx={{ fontWeight: 900 }}>
          See the impact
        </Box>
        {type === 'mobile' ? <br /> : null}
        on our clients' business
        <br />
        after going {type === 'mobile' ? <br /> : null}
        <Box component="span" className="font-satoshi-black" sx={{ fontWeight: 900 }}>
          Tech-driven
        </Box>{' '}
        with us
      </Typography>

      {/* Featured case studies label */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'start',
          justifyContent: type === 'web' ? 'center' : 'start',
          gap: 1,
          mb: '24px',
          mt: '14px',
        }}
      >
        <Typography
          variant="body1"
          className={type === 'web' ? 'font-satoshi-bold' : 'font-satoshi-medium'}
          sx={{
            color: '#425A6D',
            fontSize: type === 'web' ? '17px' : '14px',
          }}
        >
          Featured case studies↓
        </Typography>
      </Box>

      {/* Case Study Cards */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: isSlider ? 'row' : type === 'web' ? 'row' : 'column',
          gap: 3,
          mb: 5,
          overflowX: isSlider ? 'auto' : 'visible',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          width: '100%',
          pb: isSlider ? 2 : 0,
        }}
      >
        {projects.map((project) => (
          <Box
            key={project.id}
            // className="squircle-smooth"
            sx={{
              backgroundColor: '#FFFFFF',
              borderRadius: '35px',
              cornerShape: 'squircle',
              overflow: 'hidden',
              boxShadow: hideShadow
                ? 'none'
                : '0px 10px 22px 0px rgba(7, 27, 29, 0.05), 0px 41px 41px 0px rgba(7, 27, 29, 0.04), 0px 92px 55px 0px rgba(7, 27, 29, 0.03), 0px 163px 65px 0px rgba(7, 27, 29, 0.01), 0px 255px 71px 0px rgba(7, 27, 29, 0)',
              ...(hideShadow && { border: '1px solid #E0E0E0', mt: 2 }),
              transition: 'transform 0.3s ease',
              flexShrink: isSlider ? 0 : 1,
              flex: isSlider ? 'none' : 1,
              display: 'flex',
              flexDirection: 'column',
              minWidth: isSlider ? { xs: '300px', md: '400px' } : 'auto',
              maxWidth: isSlider ? { xs: '300px', md: '400px' } : '100%',
              '&:hover': {
                transform: 'translateY(-4px)',
              },
            }}
          >
            {/* Project Image */}
            <Link to={project?.isStudyAvailable ? `/portfolio/${project?.id}` : `/work/${project?.id}`}>
              <Box
                sx={{
                  width: '100%',
                  height: '280px',
                  overflow: 'hidden',
                  backgroundColor: '#E0E0E0',
                }}
              >
                {typeof project.homeImage === 'string' && project.homeImage.includes('.mp4') ? (
                  <Box
                    component="video"
                    src={project.homeImage}
                    autoPlay
                    loop
                    muted
                    playsInline
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Box
                    component="img"
                    src={project.homeImage}
                    alt={`${project.clientName} - Custom Software Development Case Study Kerala`}
                    title={`${project.clientName} - ERP NEXT & Custom Web Application`}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>
            </Link>

            {/* Project Details */}
            <Box sx={{ px: "16px", py: "24px", display: 'flex', flexDirection: 'column', flexGrow: 1 }} >
              {/* Project Title */}
              {/* <Typography
                variant="h5"
                className="font-satoshi-bold"
                sx={{
                  color: '#333333',
                  fontSize: type === 'web' ? '24px' : '20px',
                  mb: 0,
                  lineHeight: 1.3,
                }}
              >
                {project.clientName}
              </Typography> */}
              <Typography
                variant="h5"
                className="font-satoshi-regular"
                sx={{
                  color: '#333333',
                  fontSize: '12px',
                  mb: 2,
                  lineHeight: 1.3,
                }}
              >
                {project.clientNameFull || '\u00A0'}
              </Typography>

              {/* Project Description */}
              <Typography
                variant="body2"
                className="font-satoshi-medium"
                sx={{
                  // color: '#29080899',
                  fontSize: type === 'web' ? '16px' : '14px',
                  lineHeight: 1.8,
                  mb: 2,
                  flexGrow: 1,
                }}
              >
                {project.homePageContent}
              </Typography>

              {/* // case study button  */}
              {/* <Link to={project?.isStudyAvailable ? `/portfolio/${project?.id}` : `/work/${project?.id}`} style={{ textDecoration: 'none', width: 'fit-content' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    backgroundColor: '#FFEB3B', // A bright yellow matching the UI
                    color: '#000000',
                    padding: '12px 24px',
                    width: 'fit-content',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      backgroundColor: '#FDD835',
                      transform: 'translateX(4px)',
                    },
                    mt: 3
                  }}
                >
                  <EastRoundedIcon fontSize='small' />
                  <Typography
                    variant="button"
                    className="font-satoshi-bold"
                    sx={{
                      fontSize: '16px',
                      textTransform: 'none',
                      lineHeight: 1,
                      fontWeight: 500,
                      color: 'black'
                    }}
                  >
                    Read Case Study
                  </Typography>
                </Box>
              </Link> */}

              {/* Technology Tags */}
              <Box
                sx={{
                  display: 'flex',
                  gap: isMobile ? '2px' : "8px",
                  flexWrap: 'wrap',
                  mt: 'auto',
                  justifyContent: isMobile ? 'space-between' : 'start',
                }}
              >
                {project.filter.map((tech: string, idx: number) => (
                  <Chip
                    key={idx}
                    label={tech}
                    className="font-satoshi-medium"
                    sx={{
                      backgroundColor: 'transparent',
                      border: '1px solid #33333338',
                      color: '#333333',
                      fontSize: type === 'web' ? '12px' : '14px',
                      height: '32px',
                      '&:hover': {
                        backgroundColor: '#E0F7F5',
                      },
                    }}
                  />
                ))}

                <Link to={paths.public.caseStudy(project.id)}>
                  <Chip
                    label="Case Study"
                    className="font-satoshi-medium"
                    sx={{
                      backgroundColor: 'transparent',
                      border: '1px solid #33333338',
                      color: '#333333',
                      fontSize: type === 'web' ? '12px' : '14px',
                      height: '32px',
                    }}
                  />
                </Link>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FeaturedCaseStudies;
